import { UserTypesStoreInterfaceSnapshotOut } from '../state-manager/UserTypesStore'

export const UserTypesInitialStoreMock: UserTypesStoreInterfaceSnapshotOut = {
  id: 0,
  types: []
}
